import SectionWrapper from './SectionWrapper';

export default function ProjectsShimmer() {
  // Render 3 placeholder cards
  return (
    <SectionWrapper id="projects">
      {/* Heading Skeleton */}
      <div className="text-center mb-5">
        <div className="shimmer-line title-shimmer mb-2" />
        <div className="shimmer-line subtitle-shimmer mx-auto" />
      </div>

      {/* Cards Grid Skeleton */}
      <div className="row">
        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="col-sm-6 col-md-4 mb-4">
            <div className="project-shimmer-card">
              <div className="shimmer-image" />
              <div className="p-4 d-flex flex-column">
                <div className="shimmer-line short mb-2" />
                <div className="shimmer-line medium mb-2" />
                <div className="shimmer-line long mb-4" />
                <div className="shimmer-button" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
